// extracted by mini-css-extract-plugin
export default {"focus-point-container":"focus-point-container--GZI7Gb0+zE","focusPointContainer":"focus-point-container--GZI7Gb0+zE"};